module.exports = __webpack_public_path__ + "static/media/big_bell_icon.db646695.svg";